import * as ko from "knockout"

export class XinkImageViewModel {
    imageCssUrl: string;
    isDummy: KnockoutObservable<boolean>;

    constructor(public imageUrl: string, isDummy: boolean = false) {
        this.imageCssUrl = "url(" + imageUrl + ")";
        this.isDummy = ko.observable(isDummy);
    }
}



// WEBPACK FOOTER //
// ./code/elements/XinkImageViewModel.ts